
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import TaishunGlobalWorldMap from '../../assets/images/TaishunGlobalWorldMap.jpg'

const ContactPage = () => {
  return (
    <div className="min-h-screen bg-white">
      <Header />
      
      {/* Hero Section */}
      <section className="py-20 bg-gradient-to-br from-teal-600 to-blue-700 text-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h1 className="text-4xl md:text-5xl font-bold mb-6">
            Get in Touch with Taishun Global
          </h1>
          <p className="text-xl md:text-2xl text-teal-100 max-w-4xl mx-auto leading-relaxed">
            Whether you need product details, technical specifications, or a custom quote, 
            <strong> our team is ready to assist</strong>. We proudly deliver non-woven materials 
            to clients in every region of the world.
          </p>
        </div>
      </section>

      {/* Contact Information */}
      <section className="py-20 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="max-w-4xl mx-auto">
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
              {/* Contact Information */}
              <div className="bg-white rounded-lg shadow-lg p-8">
                <h2 className="text-2xl font-bold text-gray-900 mb-6">Contact Information</h2>
                
                <div className="space-y-6">
                  <div className="flex items-start space-x-4">
                    <div className="w-12 h-12 bg-teal-100 rounded-lg flex items-center justify-center flex-shrink-0">
                      <i className="ri-mail-line text-teal-600 text-xl"></i>
                    </div>
                    <div>
                      <h3 className="font-semibold text-gray-900 mb-1">Email</h3>
                      <p className="text-gray-600">info@taishunglobal.com</p>
                      <p className="text-sm text-gray-500">We respond within 24 hours</p>
                    </div>
                  </div>
                  
                  <div className="flex items-start space-x-4">
                    <div className="w-12 h-12 bg-blue-100 rounded-lg flex items-center justify-center flex-shrink-0">
                      <i className="ri-phone-line text-blue-600 text-xl"></i>
                    </div>
                    <div>
                      <h3 className="font-semibold text-gray-900 mb-1">Phone/Whatsapp</h3>
                      <p className="text-gray-600">+86 13862299662</p>
                      <p className="text-sm text-gray-500">Business hours: 9:00 AM - 6:00 PM (GMT+8)</p>
                    </div>
                  </div>
                  
                  <div className="flex items-start space-x-4">
                    <div className="w-12 h-12 bg-green-100 rounded-lg flex items-center justify-center flex-shrink-0">
                      <i className="ri-map-pin-line text-green-600 text-xl"></i>
                    </div>
                    <div>
                      <h3 className="font-semibold text-gray-900 mb-1">Head Office</h3>
                      <p className="text-gray-600">Taishun Global</p>
                      <p className="text-gray-600">Yinbei County, Shaxi Town, Taicang, Jiangsu, CN</p>
                    </div>
                  </div>
                </div>
              </div>

              {/* Additional Info */}
              <div className="space-y-8">
                <div className="bg-teal-600 rounded-lg p-8 text-white">
                  <h3 className="text-xl font-bold mb-4">🌐 Worldwide Shipping</h3>
                  <p className="mb-4">
                    We deliver to over <strong>50 countries</strong> worldwide with reliable logistics partners 
                    ensuring your materials arrive on time and in perfect condition.
                  </p>
                  <div className="flex items-center space-x-2">
                    <i className="ri-time-line"></i>
                    <span className="font-semibold">20 Years of Non-Woven Expertise</span>
                  </div>
                </div>

                <div className="bg-white rounded-lg shadow-lg p-8">
                  <h3 className="text-xl font-bold text-gray-900 mb-4">Why Choose Taishun?</h3>
                  <div className="space-y-3">
                    <div className="flex items-center space-x-3">
                      <i className="ri-check-line text-green-600"></i>
                      <span className="text-gray-700">Custom solutions for your specific needs</span>
                    </div>
                    <div className="flex items-center space-x-3">
                      <i className="ri-check-line text-green-600"></i>
                      <span className="text-gray-700">Competitive pricing with volume discounts</span>
                    </div>
                    <div className="flex items-center space-x-3">
                      <i className="ri-check-line text-green-600"></i>
                      <span className="text-gray-700">Fast turnaround times</span>
                    </div>
                    <div className="flex items-center space-x-3">
                      <i className="ri-check-line text-green-600"></i>
                      <span className="text-gray-700">Technical support and consultation</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Map Section */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-6">
              Our Global Reach
            </h2>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto">
              From our headquarters in Asia, we serve clients across all continents with 
              <strong> reliable shipping and local support</strong>.
            </p>
          </div>
          
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
            {/* Countries List */}
            <div className="bg-gray-50 rounded-lg p-8">
              <h3 className="text-2xl font-bold text-gray-900 mb-6">Countries We Serve</h3>
              <div className="grid grid-cols-2 gap-4">
                <div className="space-y-3">
                  <div className="flex items-center space-x-3">
                    <div className="w-3 h-3 bg-teal-600 rounded-full"></div>
                    <span className="text-gray-700 font-medium">United States</span>
                  </div>
                  <div className="flex items-center space-x-3">
                    <div className="w-3 h-3 bg-teal-600 rounded-full"></div>
                    <span className="text-gray-700 font-medium">Germany</span>
                  </div>
                  <div className="flex items-center space-x-3">
                    <div className="w-3 h-3 bg-teal-600 rounded-full"></div>
                    <span className="text-gray-700 font-medium">Japan</span>
                  </div>
                  <div className="flex items-center space-x-3">
                    <div className="w-3 h-3 bg-teal-600 rounded-full"></div>
                    <span className="text-gray-700 font-medium">Dubai</span>
                  </div>
                  <div className="flex items-center space-x-3">
                    <div className="w-3 h-3 bg-teal-600 rounded-full"></div>
                    <span className="text-gray-700 font-medium">United Kingdom</span>
                  </div>
                  <div className="flex items-center space-x-3">
                    <div className="w-3 h-3 bg-teal-600 rounded-full"></div>
                    <span className="text-gray-700 font-medium">France</span>
                  </div>
                  <div className="flex items-center space-x-3">
                    <div className="w-3 h-3 bg-teal-600 rounded-full"></div>
                    <span className="text-gray-700 font-medium">Australia</span>
                  </div>
                </div>
                <div className="space-y-3">
                  <div className="flex items-center space-x-3">
                    <div className="w-3 h-3 bg-teal-600 rounded-full"></div>
                    <span className="text-gray-700 font-medium">Canada</span>
                  </div>
                  <div className="flex items-center space-x-3">
                    <div className="w-3 h-3 bg-teal-600 rounded-full"></div>
                    <span className="text-gray-700 font-medium">South Korea</span>
                  </div>
                  <div className="flex items-center space-x-3">
                    <div className="w-3 h-3 bg-teal-600 rounded-full"></div>
                    <span className="text-gray-700 font-medium">Singapore</span>
                  </div>
                  <div className="flex items-center space-x-3">
                    <div className="w-3 h-3 bg-teal-600 rounded-full"></div>
                    <span className="text-gray-700 font-medium">Malaysia</span>
                  </div>
                  <div className="flex items-center space-x-3">
                    <div className="w-3 h-3 bg-teal-600 rounded-full"></div>
                    <span className="text-gray-700 font-medium">Indonesia</span>
                  </div>
                  <div className="flex items-center space-x-3">
                    <div className="w-3 h-3 bg-teal-600 rounded-full"></div>
                    <span className="text-gray-700 font-medium">Italy</span>
                  </div>
                  <div className="flex items-center space-x-3">
                    <div className="w-3 h-3 bg-teal-600 rounded-full"></div>
                    <span className="text-gray-700 font-medium">Turkey</span>
                  </div>
                </div>
              </div>
              
              <div className="mt-8 p-6 bg-teal-600 rounded-lg text-white">
                <div className="flex items-center space-x-3">
                  <i className="ri-global-line text-2xl"></i>
                  <div>
                    <h4 className="font-bold text-lg">14+ Countries Served</h4>
                    <p className="text-teal-100">Expanding globally with reliable partnerships</p>
                  </div>
                </div>
              </div>
            </div>

            {/* World Map */}
            <div className="bg-gray-100 rounded-lg overflow-hidden shadow-lg">
              <img
                src={TaishunGlobalWorldMap}
                alt="Taishun Global World Map - Countries We Serve"
                className="w-full h-full object-cover object-top"
              />
            </div>
          </div>
        </div>
      </section>

      {/* Closing Message */}
      <section className="py-20 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-6">
            Thank You for Choosing Taishun Global
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto leading-relaxed">
            Your trusted global partner for <strong>sustainable and high-performance non-woven materials</strong>. 
            We look forward to supporting your business with innovative solutions that drive success.
          </p>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default ContactPage;
